import React from 'react';

import { Checkbox } from 'antd-v5';
import cn from 'classnames';

import type { RankRequirement } from '@appTypes/esb';
import type { AdvancementRequirement } from '@modules/bulkEntry/duck/types';
import { isNotUpdateableRequirement } from '@modules/bulkEntry/duck/utils/requirementUtils';

import styles from './BulkEntryRequirement.styles.less';

interface BulkEntryRequirementProps {
  requirement: AdvancementRequirement;
  checked: boolean;
  onChange: (id: number, toggle: boolean) => void;
  isLoading?: boolean;
  disable?: boolean;
}

export const BulkEntryRequirement: React.FC<
  BulkEntryRequirementProps
> = props => {
  const { onChange, requirement, checked, isLoading, disable } = props;
  const { listNumber, name } = requirement;
  const { requirementNumber } = requirement as RankRequirement;
  const isSubRequirement = Boolean(requirement.parentRequirementId);
  const isParentRequirement = Boolean(requirement.childrenRequired);
  const isVisible = isNotUpdateableRequirement(requirement);
  const isDisabled = isLoading || disable;
  const hasChildrenReqs = Number(requirement.childrenRequired);

  return (
    <div
      key={requirement.id}
      className={cn({
        [styles.bulkEntryReqRow]: true,
        [styles.parentRequirementRow]: isParentRequirement,
        [styles.subRequirementRow]: isSubRequirement,
        [styles.hasChildrenReqs]: hasChildrenReqs,
      })}
    >
      <div
        className={cn(styles.checkbox, {
          [styles.isNotUpdateable]: isVisible,
        })}
      >
        <Checkbox
          disabled={isDisabled}
          checked={checked}
          onChange={event =>
            onChange(Number(requirement.id), event.target.checked)
          }
        />
      </div>
      <span className={styles.listNumber}>
        {requirementNumber || listNumber}
      </span>
      <div dangerouslySetInnerHTML={{ __html: name || '' }} />
    </div>
  );
};
